<template>
  <div>
    <el-alert type="warning" show-icon :closable="false" class="margin-bottom-sm"
      title="平台PV账户按平台流水 create_time 统计，与业务PV（收货日）口径不同；特价/分销/复购订单PV不进平台账户。" />

    <div class="margin-top-sm padding-sm bg-white radius">
      <div class="title">
        <span class="margin-right-sm">平台PV账户（流水日）</span>
        <el-button type="text" @click="$emit('jump', '/statistical/platformPvSummaryList')">查看明细</el-button>
      </div>
      <div class="margin-top-sm padding radius stat-grid-3">
        <StatisticalItem title="PV变更" :today="p.today.platformChangePv" :yesterday="p.yesterday.platformChangePv" :history="p.today.platformEndPv" :showHistory="true" />
        <StatisticalItem title="PV获得" :today="p.today.platformGainPv" :yesterday="p.yesterday.platformGainPv" />
        <StatisticalItem title="PV消耗" :today="p.today.platformConsumePv" :yesterday="p.yesterday.platformConsumePv" />
      </div>
      <div class="margin-top-sm padding radius stat-grid-4">
        <StatisticalItem title="订单产生PV" :today="p.today.orderPv" :yesterday="p.yesterday.orderPv" />
        <StatisticalItem title="代理PV消耗" :today="p.today.agentConsumePv" :yesterday="p.yesterday.agentConsumePv" />
        <StatisticalItem title="手工变更PV" :today="p.today.platformManualChangePv" :yesterday="p.yesterday.platformManualChangePv" />
        <StatisticalItem title="退款扣减PV" :today="p.today.platformOrderRefundPv" :yesterday="p.yesterday.platformOrderRefundPv" />
      </div>
      <div class="margin-top-sm text-gray" v-if="b.today.platformGainPvSnapshot != null">
        参考：同日业务收货汇总中「平台PV获得快照」={{ b.today.platformGainPvSnapshot }}（收货日≠流水日时仅作 adjacent 参考）
      </div>
    </div>
  </div>
</template>
<script>
import StatisticalItem from './StatisticalItem.vue'

export default {
  name: 'FinancePlatformPvPanel',
  components: { StatisticalItem },
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    p() { return this.data.platformPvSummaryMap || { today: {}, yesterday: {} } },
    b() { return this.data.bizPvReconcileMap || { today: {}, yesterday: {} } },
  },
}
</script>
<style scoped>
.stat-grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; background-color: #f0f0f0; }
.stat-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; background-color: #f0f0f0; }
.text-gray { color: #909399; font-size: 13px; }
</style>
